<template>
  <modal :name="name" class="popup_dialog"
    transition="nice-modal-fade"
    :width="width"
    :height="height"
    :delay="100"
    :resizable="false"
    :draggable="'.modal-header'"
    :clickToClose="false"
    classes='q-v--modal' >
      <div class="modal-content" :style="{cursor: 'default'}">
        <div class="modal-header" :class="{df: isDisplayFlex}">
          <div class="dialog-icon" :class="[iconClass]"></div>
          <slot>
            <div class="dialog-header">{{dialogHeader}}</div>
          </slot>
          <div class="icon-btn_close modal-close" @click="callback"></div>
        </div>
        <div class="modal-body" v-if="dialogMessage">
          <div class="dialog-content">
            <slot>
              <div class="dialog-message">{{dialogMessage}}
                <div class="dialog-message2">{{dialogMessage2}}</div>
                <div class="dialog-message2">{{dialogMessage3}}</div>
                <div class="dialog-message4">{{dialogMessage4}}</div>
                <div class="dialog-message4">{{dialogMessage5}}</div>
              </div>
            </slot>
        </div>
        </div>
        <div class="modal-footer">
          <div class="buttons" v-if="onlyOk || pwdWarn">
            <div class="q-button blue-btn-full" @click="callback">{{$t('ok')}}</div>
          </div>
          <div class="buttons" v-else>
            <div class="q-button blue-btn-full" :class="{reset: (confirmBtnTitle === 'reset')}" @click="callback">{{$t(confirmBtnTitle)}}</div>
            <div class="q-button" @click="onNo()">{{$t('cancel')}}</div>
          </div>
        </div>
      </div>
  </modal>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  props: {
    name: String,
    selHeight: Number,
    icon: String,
    dialogHeader: String,
    dialogMessage: String,
    dialogMessage2: String,
    dialogMessage3: String,
    dialogMessage4: String,
    dialogMessage5: String,
    callback: {
      type: Function,
      default () {}
    },
    isDisplayFlex: Boolean,
    onlyOk: Boolean,
    type: String,
    pwdWarn: Boolean
  },
  methods: {
    onClose () {
      if (this.pwdWarn) this.onOkClick()
      this.closeModal(this.name)
      this.$modal.hide(this.name)
      if (this.$router.currentRoute.name.includes('update')) {
        this.$store.commit('setUpdateStatus', false)
        this.$store.commit('setProgress', 0)
      }
    },
    onOkClick () {
      if (this.onlyOk) {
        this.onNo()
      } else if (this.pwdWarn) {
        this.callback()
      }
    },
    onNo () {
      this.$log.info('onNo')
      this.closeModal(this.name)
      this.$modal.hide(this.name)
      if (this.$router.currentRoute.name.includes('update')) {
        this.$store.commit('setUpdateStatus', false)
        this.$store.commit('setProgress', 0)
      }
    },
    ...mapMutations([
      'openModal',
      'closeModal'
    ])
  },
  computed: {
    width () {
      if (this.icon === 'w') {
        return 500
      } else {
        return 300
      }
    },
    height () {
      if (this.selHeight) {
        return this.selHeight
      } else {
        return 'auto'
      }
    },
    iconClass () {
      switch (this.icon) {
        case 'w':
          return 'icon-warning'
        case 'i':
          return 'icon-info-border'
        case 'h':
          return 'icon-help'
        case 'e':
          return 'icon-error'
        default:
          return 'empty'
      }
    },
    confirmBtnTitle () {
      switch (this.type) {
        case 'c':
          return 'clear'
        case 'd':
          return 'delete'
        // case 'e':
        //   return 'enable'
        // case 'l':
        //   return 'leave'
        case 'r':
          return 'reset'
        case 's':
          return 'save'
        case 'u':
          return 'update'
        default:
          return 'yes'
      }
    },
    ...mapState(['count', 'modalList']),
    ...mapGetters(['getTopModalName'])
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/modal.scss';
.popup_dialog {
  z-index: 10000
}
.dialog-message4 {
  margin-top: 14px;
  color: #195a87;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupCallBack.vue